import { createAction, props } from '@ngrx/store';
import { Equipment } from '../_models';

// Action types
export const loadEquipments = createAction('[Equipment] Load Equipments');
export const loadEquipmentsSuccess = createAction(
  '[Equipment] Load Equipments Success',
  props<{ equipments: Equipment[] }>()
);
export const loadEquipmentsFailure = createAction(
  '[Equipment] Load Equipments Failure',
  props<{ error: any }>()
);

export const addEquipment = createAction(
  '[Equipment] Add Equipment',
  props<{ equipment: Equipment }>()
);
export const addEquipmentSuccess = createAction(
  '[Equipment] Add Equipment Success',
  props<{ equipment: Equipment }>()
);
export const addEquipmentFailure = createAction(
  '[Equipment] Add Equipment Failure',
  props<{ error: any }>()
);

export const updateEquipment = createAction(
  '[Equipment] Update Equipment',
  props<{ equipment: Equipment }>()
);
export const updateEquipmentSuccess = createAction(
  '[Equipment] Update Equipment Success',
  props<{ equipment: Equipment }>()
);
export const updateEquipmentFailure = createAction(
  '[Equipment] Update Equipment Failure',
  props<{ error: any }>()
);

export const deleteEquipment = createAction(
  '[Equipment] Delete Equipment',
  props<{ id: number }>()
);
export const deleteEquipmentSuccess = createAction(
  '[Equipment] Delete Equipment Success',
  props<{ id: number }>()
);
export const deleteEquipmentFailure = createAction(
  '[Equipment] Delete Equipment Failure',
  props<{ error: any }>()
);
